import { delay } from 'redux-saga'
import { take, put, call, fork, cancel, select  } from 'redux-saga/effects'
import * as types from '../constants/ActionTypes';
import {checkIfPaused, getGameSpeed, getCurrentEvent, lookingForGameScenes, playScenes, playEventSounds} from './common'
import { getInterval } from '../components/Pitch/gameJson'

export default function* full () {
    console.log('main saga started...')

    while(true) {
        let paused = yield select(checkIfPaused);

        if(paused)
            yield take(types.START_GAME);

        const loop = yield fork(gameLoop)

        const action = yield take([types.PAUSE_GAME, types.MOVE_TO_MINUTE, types.MOVE_TO_EVENT]);
        yield cancel(loop)

        if(action.type === types.MOVE_TO_MINUTE || action.type === types.MOVE_TO_EVENT){
            let gameSpeed = yield select(getGameSpeed)
            yield call(delay, gameSpeed*30)
        }
    }
}

function* gameLoop() { 
    while(true) {
        let currentFrame = yield select(getCurrentEvent)
        let gameSpeed = yield select(getGameSpeed)
        let time = getInterval(currentFrame)
        yield put({ type: types.MOVE_TO_NEXT_EVENT })
        yield call(delay, gameSpeed * time)

        let nextFrame = window.Json.game[currentFrame];
        playEventSounds(nextFrame);
        let scenes = lookingForGameScenes(nextFrame)
        if(scenes != null)
            yield* playScenes(scenes)
    }
}


/** WEBPACK FOOTER **
 ** ./src/sagas/full.js
 **/